// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-container__2aK7y","buttons_wrap":"styles-buttons_wrap__2W9lE","btn":"styles-btn__3K1HY"};